import ajax from '@/libs/ajax';

// 待申请发票列表
export const getSettlementList = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/settlement/list`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}

// 处理中、已开票列表
export const getSaleInvoiceList = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/saleInvoice/list`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}

// 平台模式下获取开票组织
export const getSettlementOrgsInPlatform = () => {
  return ajax.request({ url: `/orginazation/bizproxy/agent/settlement/org/list`, method: 'get', data: { isArchive: 1 } }).then((data) => {
    data &&
      data.map((v) => {
        v.value = v.id;
        v.title = v.name;
      });
    return data;
  });
};

// 发票卡片生单接口
export const getSaleInvoiceCardData = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/saleInvoice/pullVoucher`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}

// 发票保存接口
export const saveInvoiceCardData = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/saleInvoice/save`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}

// 发票修改商品行计价数量
export const modifyCount = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/saleInvoice/check`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}

// 发票列表客户确认
export const balanceConfirm = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/saleInvoice/agentConfirm`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}

// 发票列表取消确认接口
export const balanceCancelConfirm = (data) => {
  return ajax
  .request({
    url: `/marketingbill/invoiceApply/saleInvoice/agentDisConfirm`,
    method: 'post',
    data: {
      datatype: 'json',
      isMarket: 1,
      data
    }
  });
}
